import Highcharts from '../../extensions/Highcharts/js/highchartsInit';

// Registration is idempotent; highcharts-more comes first because dumbbell builds on its arearange
const modules = [
    require('highcharts/highcharts-more'),
    require('highcharts/modules/sankey'),
    require('highcharts/modules/heatmap'),
    require('highcharts/modules/treemap'),
    require('highcharts/modules/sunburst'),
    require('highcharts/modules/dumbbell'),
];

modules.forEach(register => register(Highcharts));
